<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  //import { toast } from "../../framework/js/toast.js";
  import Question from "./step/Question.svelte";
  import ReadBack from "./step/ReadBack.svelte";
  import { initializeStore, initialSteps } from "../../stores/BriefStepStore.js";
  import { ACTIVE_BRIEF_TYPE_UUID } from "../../framework/js/briefConstants.js";
  import { spinner } from "../../framework/js/spinner";
  import { fade } from "svelte/transition";

  const dispatch = createEventDispatcher();
  let briefSteps: any[] = [];
  let currentStepData: any = {};
  let showBrief = false;
  let currentStep = 1;
  let currentAnswer = "";
  let localAnswers: any = {};
  let uuid: string;

  async function setupQuestions() {
    spinner.show();
    try {
      await initializeStore(ACTIVE_BRIEF_TYPE_UUID);
      briefSteps = initialSteps;
      toggleBrief();
  
      const recordRaw = await localStorage.getItem("localBriefAnswers_guest");
      const record: Record<string, unknown> = recordRaw ? (JSON.parse(recordRaw) as Record<string, unknown>) : {};

      const transformedRecord: Record<number, unknown> = {};
      Object.entries(record).forEach(([key, value], index) => {
        transformedRecord[index + 1] = value;
      });
  
      localStorage.setItem(
        "localBriefAnswers_guest",
        JSON.stringify(transformedRecord),
      );
  
      loadCurrentAnswer();
    } catch (error) {
      console.error("Error loading questions:", error);
    } finally {
      spinner.hide();
    }
  }

  function setStepData() {
    currentStepData = briefSteps[currentStep - 1];
  }

  function handleClick(e: CustomEvent<{ dir: string; answer: unknown }>) {
    const { dir, answer } = e.detail;
    if (dir === "adjust") {
      currentStep = 1;
      setStepData();
      loadCurrentAnswer();
      return;
    }
    if (currentStepData?.step_type !== "readback") {
      updateAnswer(currentStep, answer);
    }

    if (dir === "next" && currentStep < briefSteps.length) {
      currentStep++;
    } else if (dir === "prev" && currentStep > 1) {
      currentStep--;
    }
    setStepData();
    loadCurrentAnswer();
  }

  function loadCurrentAnswer() {
    currentAnswer = getCurrentAnswer();
  }

  function getCurrentAnswer() {
    return getLocalAnswers()[currentStep];
  }

  function updateAnswer(id: any, answer: any) {
    let currentAnswers = getLocalAnswers();
    let currentGuestAnswers = getLocalGuestAnswers();
    currentGuestAnswers[currentStepData.question_uuid] = answer;
    currentAnswers[id] = answer;
    localStorage.setItem(
      `localBriefAnswers_guest`,
      JSON.stringify(currentAnswers),
    );
    localStorage.setItem(
      `localBriefAnswers_guest_array`,
      JSON.stringify(currentGuestAnswers),
    );
    localAnswers = currentAnswers;
  }

  function handleAutosave(e: CustomEvent<{ answer: string }>) {
    const { answer } = e.detail;
    if (answer === undefined || answer === null) return;
    updateAnswer(currentStep, answer);
  }

  function resetBrief() {
    localStorage.removeItem(`localBriefAnswers_guest`);
    localAnswers = {};
    currentStep = 1;
    setStepData();
    loadCurrentAnswer();
  }

  function getLocalAnswers() {
    return JSON.parse(localStorage.getItem(`localBriefAnswers_guest`) || "{}");
  }

  function getLocalGuestAnswers() {
    return JSON.parse(
      localStorage.getItem(`localBriefAnswers_guest_array`) || "{}",
    );
  }

  onMount(() => {
     localStorage.setItem('localBriefAnswers_guest','');
     localStorage.setItem('localBriefAnswers_guest_array','');
    setupQuestions();
  });

  function toggleBrief() {
    showBrief = !showBrief;
    setStepData();
  }
</script>

<!-- <div class="ui container conwrp"> -->
  <div class="ui hidden divider"></div>
  {#if showBrief}
  <div class="w640 hfull flex-end {currentStepData.step_type === 'xplorit_genai' ? 'center-fixed' : 'center-x-fixed'}">
    <div class="ui wfull" style="position: relative; min-height: 400px;">
      {#each briefSteps as step (step.id)}
        {#if currentStep === step.id}
          <div transition:fade style="position: absolute; width: 100%;">

            {#if step.step_type === "question"}
              <Question
                on:navigate={handleClick}
                on:autosave={handleAutosave}
                stepData={currentStepData}
                answer={currentAnswer}
                displayReport={briefSteps.indexOf(step) === briefSteps.length - 2}
              />
            {:else if step.step_type === "readback"}
              <ReadBack
                on:navigate={handleClick}
                decision={String(localAnswers[1] || "")}
                trigger={String(localAnswers[2] || "")}
              />
            {:else if step.step_type === "xplorit_genai"}
              <div class="ui icon message"><i class="info circle icon"></i><div class="content"><p>Please Login / Register to get your results.</p></div></div>
              <div class="flow-center">
                <a href="#/login" class="ui primary button">Login</a>
                <a href="#/signup" class="ui green button">Register</a>
              </div>
            {/if}
          </div>
        {/if}
      {/each}
    </div>
  </div>
  {#if !currentStepData.bubble && currentStepData.step_type === "question"}
          <img src="./src/assets/people.png" alt="people" class="brief-people-bg" transition:fade />
        {/if}
  {/if}
<!-- </div> -->